import { Vue, Component, Prop } from "vue-property-decorator";
import { _isMobile } from "@/libs/tools";

@Component
export default class BannerV3 extends Vue {
    @Prop() readonly item: any;
    private banner: string = "";
    private text: string = "";
    mounted() {
        this.banner = _isMobile() ? this.item.web : this.item.pc;
        this.text = this.item.text ? this.item.text : "";
    }
}
//@ts-ignore
export { default as BannerV3 } from "./index.vue";
